import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { faIcon } from "@utils/faIcon"

import NavSidebarItem from "@organisms/NavSidebar/components/NavSidebarItem/NavSidebarItem"

export default function HelpCenter() {
    const { openHelpCenter } = useUserNavigationUtils()

    return (
        <NavSidebarItem
            onClick={() => openHelpCenter()}
            label="Help center"
            icon={faIcon({ name: "circle-question", style: "regular" })}
            iconActive={faIcon({ name: "circle-question", style: "solid" })}
        />
    )
}
